import React, { useState } from 'react';
import { Query } from 'react-apollo';
import { Box, Button, Heading, Text } from 'rebass';
import styled from 'styled-components';
import ConfirmModal from '../components/ConfirmModal';
import PleaseWait from '../components/PleaseWait';
import { ADMIN_GET_CARE_MANAGERS_LIST } from '../graphql';
import CareManagersList from './adminCareManagers/CareManagersList';
import ModalSearchUser from './adminCareManagers/ModalSearchUser';

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  padding: 48px 6px 0 6px;
`;
const ModalInner = styled(Box)`
  max-width: 80vw;
  min-width: 80vw;
  width: 100%;
  max-height: 700px;
  overflow-y: auto;
`;

const AdminCareManagers = () => {
  const [findUser, setFindUser] = useState(false);
  return (
    <Container>
      <Heading flex={1} mb={4}>CARE MANAGERS MANAGEMENT</Heading>
      <Text mb={3} color='red'>Patient with no linked care managers (those who became member prior to the feature) won't appear in the list</Text>
      <Query query={ADMIN_GET_CARE_MANAGERS_LIST}>
        {({ data, loading, error }) => {
          if (!!loading) return <PleaseWait />;
          return (
            <>
              <CareManagersList data={data} />
              
              <Button variant={'primary'} mt={4} onClick={() => setFindUser(true)}>
                Batch change Patients Care Manager
              </Button>

              <ConfirmModal
                childrenManaged
                isOpen={!!findUser}
                confirmLabel="create"
                onClose={() => {
                  setFindUser(false);
                }}
                onBackgroundClick={() => {
                  setFindUser(false);
                }}
                onEscapeKeydown={() => {
                  setFindUser(false);
                }}
                onConfirm={() => {
                  setFindUser(false);
                }}
              >
                <ModalInner>
                  <ModalSearchUser careManagers={data.adminGetCareManagersList} />
                </ModalInner>
              </ConfirmModal>
            </>
          );
        }}
      </Query>
    </Container>
  );
};

export default AdminCareManagers;
